module.exports = __webpack_public_path__ + "static/img/lotteryGame.0d02ffb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/hotGame/lotteryGame.webp
// module id = ko96
// module chunks = 3